import { Databases, ID, Query, Storage } from "appwrite";
import { getClient } from "../login/auth_service";
import axios from "axios";

// const remoteIP = process.env.REACT_APP_REMOTE_IP;

const projectID = process.env.REACT_APP_PROJECT_ID;
const databaseID = process.env.REACT_APP_DB_ID;

const feedbacksCollectionID = process.env.REACT_APP_FEEDBACKS_COLLECTION_ID;
const webpMetadataCollectionID =process.env.REACT_APP_WEBP_METADATA_COLLECTION_ID;
const iterationsCollectionID = process.env.REACT_APP_ITERATIONS_COLLECTION_ID;
const discourseCollectionID = process.env.REACT_APP_DISCOURSE_COLLECTION_ID;
const discourseTypeCollectionID =process.env.REACT_APP_DISCOURSE_TYPE_COLLECTION_ID;

const webpBucketID = process.env.REACT_APP_WEBP_BUCKET_ID;
const audioBucketID = process.env.REACT_APP_AUDIO_BUCKET_ID;

// const serverIP = "103.252.84.6";
const backendDomain = process.env.REACT_APP_APPWRITE_BACKEND_DOMAIN;



export async function uploadAll(rows) {
  const client = getClient();
  const storage = new Storage(client);
  const databases = new Databases(client);

  let existingTitles = [];

  // Step 1: Check all rows for duplicate metadata BEFORE uploading
  for (const row of rows) {
    const enTitle = row.enTitle.trim(); //.toLowerCase();
    const [exists] = await duplicateWebpMetadataExist(enTitle, databases);

    if (exists) {
      existingTitles.push(enTitle);
    }
  }

  // If any duplicates exist, return and abort upload
  if (existingTitles.length > 0) {
    return { duplicates: existingTitles };
  }

  // Proceed with uploads since no duplicates found
  const responses = [];
  const categorySet = new Set();

  for (const row of rows) {
    const docID = ID.unique();
    const enTitle = row.enTitle.trim(); //.toLowerCase();
    const category = row.category.trim(); //.toLowerCase();

    try {
      const [webpUpload, audioUpload] = await Promise.all([
        storage.createFile(webpBucketID, ID.unique(), row.webpFile),
        storage.createFile(audioBucketID, ID.unique(), row.audioFile),
      ]);

      const webpUrl = `https://${backendDomain}/v1/storage/buckets/${webpBucketID}/files/${webpUpload.$id}/view?project=${projectID}`;
      const audioUrl = `https://${backendDomain}/v1/storage/buckets/${audioBucketID}/files/${audioUpload.$id}/view?project=${projectID}`;

      await databases.createDocument(
        databaseID,
        webpMetadataCollectionID,
        docID,
        {
          enTitle,
          dzTitle: row.dzTitle,
          category,
          categories: [category],
          webpUrl,
          audioUrl,
          webpUrls: [webpUrl],
          audioUrls: [audioUrl],
        }
      );

      responses.push({
        [row.filename]: [webpUpload, audioUpload],
      });

      if (!categorySet.has(category)) {
        categorySet.add(category);
        const result = await addCategory(category);
        if (result[0] === true) {
          await updateCategory(result[1], databases);
        }
      }

      // // add category & increment iteration
      // if (!categories.includes(rows[i].category)) {
      //     categories.push(rows[i].category);
      //     const result = await addCategory(categories[i]);
      //     if (result[0] === true) {
      //         await updateCategory(result[1], databases);
      //     }
      // }
    } catch (error) {
      return { error };
    }
  }

  return { responses };
}

export async function updateWepMetadata(rows, toDeleteFiles) {
  const client = getClient();
  const storage = new Storage(client);
  const databases = new Databases(client);
  let _c = 0;
  // 1. Check for enTitle duplicates before doing anything
  const duplicateEnTitles = [];

  for (const row of rows) {
    const enTitleQuery = await databases.listDocuments(
      row["$databaseId"],
      row["$collectionId"],
      [
        Query.equal("enTitle", row["enTitle"]),
        Query.notEqual("$id", row["$id"]),
      ]
    );

    if (enTitleQuery.total > 0) {
      duplicateEnTitles.push(row["enTitle"]);
    }
  }

  if (duplicateEnTitles.length > 0) {
    // Return early if any duplicates found
    return {
      success: false,
      message: "Duplicate English titles found.",
      duplicateEnTitles,
    };
  }

  // 2. No duplicates, proceed with updates
  deleteFiles(toDeleteFiles).then(() => {});

  try {
    for (const row of rows) {
      let _webpUrls = [...row.webpUrls];
      let _audioUrls = [...row.audioUrls];
      let _count = 0;
      // check if webUrls or audios are in blob to upload to
      for (const webpUrlOrBlob of row.webpUrls) {
        if (webpUrlOrBlob.includes("blob")) {
          try {
            _webpUrls = _webpUrls.filter((u) => !u.includes("blob"));

            for (const file of row.webpFiles) {
              const _webpFileID = await storage.createFile(
                webpBucketID,
                ID.unique(),
                file
              );
              const urr = `https://${backendDomain}/v1/storage/buckets/${webpBucketID}/files/${_webpFileID.$id}/view?project=${projectID}`;
              _webpUrls = [..._webpUrls, urr];
            }
            break;
          } catch (error) {
            _webpUrls = _webpUrls.filter((u) => u !== webpUrlOrBlob);
          }
        }
        _count++;
      }
      _count = 0;
      for (const audioUrlOrBlob of row.audioUrls) {
        if (audioUrlOrBlob.includes("blob")) {
          try {
            _audioUrls = _audioUrls.filter((u) => !u.includes("blob"));
            for (const audioFile of row.audioFiles) {
              const _audioFileID = await storage.createFile(
                audioBucketID,
                ID.unique(),
                audioFile
              );
              const urrAudio = `https://${backendDomain}/v1/storage/buckets/${audioBucketID}/files/${_audioFileID.$id}/view?project=${projectID}`;
              _audioUrls = [..._audioUrls, urrAudio];
            }
          } catch (error) {
            _audioUrls = _audioUrls.filter((u) => u !== audioUrlOrBlob);
          }
        }
        _count++;
      }
      // console.log(_count);
      const data = {
        audioUrl: _audioUrls[0],
        categories: row["categories"],
        category: row["category"],
        dzTitle: row["dzTitle"],
        enTitle: row["enTitle"],
        webpUrl: _webpUrls[0],
        webpUrls: _webpUrls,
        audioUrls: _audioUrls,
      };
      await databases.updateDocument(
        row["$databaseId"],
        row["$collectionId"],
        row["$id"],
        data
      );
      _c++;
    }
    return {
      success: true,
      updatedCount: _c,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

async function deleteFiles(files) {
  // console.log(files);
  const client = getClient();
  const storage = new Storage(client);
  for (const blobOrUrl of files) {
    if (!blobOrUrl.includes("blob")) {
      const url = blobOrUrl.split("/");
      const _buckId = url[6];
      const _fileId = url[8];
      try {
        await storage.deleteFile(_buckId, _fileId);
      } catch (error) {}
    }
  }
}

//2
export async function getDataByCategory(category) {
  const databases = new Databases(getClient());
  try {
    const normalizedCategory = category.toLowerCase(); //.toLowerCase();
    let sort;
    if (normalizedCategory === 'alphabet' || normalizedCategory === 'གསལ་བྱེད་སུམ་ཅུ'){
         sort = Query.orderAsc("enTitle");
    }else{
         sort = Query.orderDesc("$createdAt");
    }
    const response = await databases.listDocuments(
      databaseID,
      webpMetadataCollectionID,
      [
        Query.equal("category", category),
        Query.limit(100),
        sort
        // Query.orderDesc("$createdAt"), // newest first
        // Query.orderAsc("$createdAt"), // newest last
      ]
    );

        const sortedDocs = [...response.documents].sort((a, b) => {
        const aExactMatch = a.enTitle?.toLowerCase() === normalizedCategory;
        const bExactMatch = b.enTitle?.toLowerCase() === normalizedCategory;

        if (aExactMatch && !bExactMatch) return -1;
        if (!aExactMatch && bExactMatch) return 1;
        return 0;
      });
      return { documents: sortedDocs };
  // return response;
   
  } catch (error) {
    console.error(`Failed to fetch signs under ${category}:`, error);
    throw new Error(
      `Could not fetch signs under ${category}. Please try again later.`
    );
  }
}

export async function getDataBySign(signName) {
  const databases = new Databases(getClient());
  try {
    const response = await databases.listDocuments(
      databaseID,
      webpMetadataCollectionID,
      [Query.equal("enTitle", signName)]
    );
    return response;

  } catch (error) {
    console.error(`Failed to fetch ${signName}:`, error);
    throw new Error(
      `Could not fetch sign: ${signName}. Please try again later.`
    );
  }
}

export async function searchSign(searchTerm) {
  const databases = new Databases(getClient());
  try {
    // Run both queries separately
    const [enRes, dzRes] = await Promise.all([
      databases.listDocuments(databaseID, webpMetadataCollectionID, [
        Query.startsWith("enTitle", searchTerm),
        // Query.equal("enTitle", searchTerm),
        Query.limit(5),
      ]),
      databases.listDocuments(databaseID, webpMetadataCollectionID, [
        Query.startsWith("dzTitle", searchTerm),
        Query.limit(5),
      ]),
    ]);

    // Merge and deduplicate results
    const seen = new Set();
    const allDocs = [...enRes.documents, ...dzRes.documents].filter((doc) => {
      if (seen.has(doc.$id)) return false;
      seen.add(doc.$id);
      return true;
    });

    // Replace https with http in URLs
    const cleanedDocs = allDocs.map((doc) => ({
      id: doc.$id,
      enTitle: doc.enTitle,
      dzTitle: doc.dzTitle,
      // audioUrl: convertHttpsToHttp(doc.audioUrl),
      // webpUrl: convertHttpsToHttp(doc.webpUrl),
    }));

    return { documents: cleanedDocs };
  } catch (error) {
    console.error(`${searchTerm} not found`, error);
    throw new Error(`${searchTerm} not found`);
  }
}

//remove later
export async function getAllEnTitles() {
  const databases = new Databases(getClient());
  const limit = 100;
  let allEnTitles = [];

  let hasMore = true;
  let lastDoc = null;

  while (hasMore) {
    try {
      const queries = [Query.limit(limit), Query.orderAsc('$createdAt')];

      if (lastDoc) {
        queries.push(Query.cursorAfter(lastDoc.$id));
      }

      const response = await databases.listDocuments(
        databaseID,
        webpMetadataCollectionID,
        queries
      );

      const currentTitles = response.documents
        .map((doc) => doc.enTitle)
        .filter((title) => typeof title === 'string' && title.trim() !== '');

      allEnTitles.push(...currentTitles);

      if (response.documents.length < limit) {
        hasMore = false; // No more pages
      } else {
        lastDoc = response.documents[response.documents.length - 1];
      }
    } catch (error) {
      console.error('Error fetching enTitles:', error);
      throw new Error('Could not fetch enTitles. Please try again later.');
    }
  }
  return allEnTitles;
}

// export async function updateWepMetadataCat(rows) {

//   const databases = new Databases(getClient());

//   for (const row of rows) {
//     const oldCategory = row.category;
//     const newCategory = row.new_category;
//     const iterationId = row.$id;

//     try {
//       // 1. Update webpMetadataCollectionID documents with old category
//       let lastDoc = null;
//       const limit = 100;

//       while (true) {
//         const queries = [
//           Query.equal("category", oldCategory),
//           Query.limit(limit),
//         ];

//         if (lastDoc) {
//           queries.push(Query.cursorAfter(lastDoc.$id));
//         }

//         const response = await databases.listDocuments(
//           databaseID,
//           webpMetadataCollectionID,
//           queries
//         );

//         if (response.documents.length === 0) break;

//         for (const doc of response.documents) {
//           await databases.updateDocument(
//             databaseID,
//             webpMetadataCollectionID,
//             doc.$id,
//             {
//               category: newCategory,
//             }
//           );
//         }

//         lastDoc = response.documents[response.documents.length - 1];
//         if (response.documents.length < limit) break;
//       }

//       // 2. Update the category in iterationsCollectionID
//       await databases.updateDocument(
//         databaseID,
//         iterationsCollectionID,
//         iterationId,
//         {
//           category: newCategory,
//         }
//       );

//       console.log(`✅ Updated iteration "${iterationId}" and all related metadata from "${oldCategory}" → "${newCategory}"`);
//     } catch (error) {
//       console.error(`❌ Failed to update for iteration "${iterationId}":`, error);
//       return {
//         success:false
//       }
//     }
//   }

//     return {
//     success:true
//   }
// }


// export async function getOffsetDataByCategory(lastId, category) {
//   const databases = new Databases(getClient());
//   return await databases.listDocuments(databaseID, webpMetadataCollectionID, [
//     Query.equal("category", category),
//     Query.limit(100),
//     Query.offset(100),
//   ]);
// }


//zz
export async function deleteDataInDatabase(row) {
  const docId = row.$id;
  const audioFileId = row.audioUrl.split("files")[1].split("/")[1];
  const webpFileId = row.webpUrl.split("files")[1].split("/")[1];

  const client = getClient();
  const storage = new Storage(client);
  const databases = new Databases(client);

  try {
    return await Promise.all([
      // delete document
      databases.deleteDocument(databaseID, webpMetadataCollectionID, docId),
      // delete webp file
      storage.deleteFile(webpBucketID, webpFileId),
      // delete audio file
      storage.deleteFile(audioBucketID, audioFileId),
    ]);
  } catch (error) {
    return error;
  }
}


// Quiz
export async function getQuizByCategory(category) {
  const databases = new Databases(getClient());

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  try {
    const response = await databases.listDocuments(
      databaseID,
      webpMetadataCollectionID,
      [Query.equal("category", category), Query.limit(100)]
    );

    let quiz = response.documents.map((doc) => {
      return {
        enTitle: doc.enTitle,
        dzTitle: doc.dzTitle,
        answer: doc.enTitle,
        category: doc.category,
        audioUrl: doc.audioUrl,
        webpUrl: doc.webpUrl,
      };
    });
    let shuffledQuiz = shuffleArray(quiz);

    return {
      documents: shuffledQuiz,
    };
  } catch (error) {
    console.error(`Failed to fetch quiz under ${category}:`, error);
    throw new Error(
      `Could not fetch quiz under ${category}. Please try again later.`
    );
  }
}


//Category
export async function getCategories() {
  const databases = new Databases(getClient());

  let allDocuments= [];
  let lastDocument= null;
  const limit = 100;  //appwrite default limit is 100

  try {
    while (true) {
      const queries = [
        Query.orderAsc("category"),
        // Query.orderDesc("$createdAt"),
        Query.limit(limit),
      ];

      if (lastDocument) {
        queries.push(Query.cursorAfter(lastDocument.$id));
      }

      const response = await databases.listDocuments(
        databaseID,
        iterationsCollectionID,
        queries
      );

      if (response.documents.length === 0) break;

      allDocuments.push(...response.documents);

      // Prepare for next loop
      lastDocument = response.documents[response.documents.length - 1];

      if (response.documents.length < limit) break; // No more pages
    }

    return {
      documents: allDocuments
    };
  } catch (error) {
    console.error("Failed to fetch categories:", error);
    throw new Error(
      `Could not fetch signs categories. Please try again later. ${error}`
    );
  }
}

export async function addNewCategory(category, iteration = 1) {
  const databases = new Databases(getClient());
  // const categoryLower = category.toLowerCase();
   const categoryLower = category;

  try {
    // Step 1: Check if category already exists
    const existing = await databases.listDocuments(
      databaseID,
      iterationsCollectionID,
      [Query.equal("category", categoryLower)]
    );

    if (existing.total > 0) {
      return {
        success: false,
        message: `Category "${categoryLower}" already exists in the system. Please add a different category instead and try again.`,
      };
    }

    // Step 2: Create new document if not exists
    const newDocument = await databases.createDocument(
      databaseID,
      iterationsCollectionID,
      ID.unique(),
      { category: categoryLower, iteration: iteration }
    );

    return {
      success: true,
      message: `Category '${categoryLower}' added successfully.`,
      document: newDocument,
    };
  } catch (error) {
    return { success: false, message: error.message || "An error occurred." };
  }
}

export async function addCategory(category, iteration = 1) { //old
  const databases = new Databases(getClient());
  const [alreadyExist, promise] = await duplicateIterationDocumentExist(
    category,
    databases
  );
  if (!alreadyExist) {
    //create if category does not exist ?
    try {
      return await databases.createDocument(
        databaseID,
        iterationsCollectionID,
        ID.unique(),
        { category: category, //.toLowerCase(),
           iteration: iteration }
      );
    } catch (error) {
      return error;
    }
  }
  return [true, promise];
}

// 
export async function updateCategoryWithRollback(oldCategory, newCategory) {
  const databases = new Databases(getClient());

  let originalCategoryDoc = null;
  let affectedSignDocs = [];

  try {
    // 1️⃣ Fetch category doc
    const categoryDocs = await databases.listDocuments(
      databaseID,
      iterationsCollectionID,
      [Query.equal("category", oldCategory)]
    );

    if (categoryDocs.total === 0) {
      throw new Error("Category not found");
    }

    originalCategoryDoc = categoryDocs.documents[0];

    // 2️⃣ Fetch affected sign docs
    const signDocs = await databases.listDocuments(
      databaseID,
      webpMetadataCollectionID,
      [Query.equal("category", oldCategory), Query.limit(100)]
    );

    affectedSignDocs = signDocs.documents.map(doc => ({
      id: doc.$id,
      category: doc.category
    }));

    // 3️⃣ Update category document
    await databases.updateDocument(
      databaseID,
      iterationsCollectionID,
      originalCategoryDoc.$id,
      { category: newCategory }
    );

    // 4️⃣ Update all related sign docs
    for (const doc of signDocs.documents) {
      await databases.updateDocument(
        databaseID,
        webpMetadataCollectionID,
        doc.$id,
        { category: newCategory }
      );
    }

    return { success: true };

  } catch (error) {
    console.error("Update failed, rolling back...", error);

    // 🔁 ROLLBACK
    try {
      // rollback category doc
      if (originalCategoryDoc) {
        await databases.updateDocument(
          databaseID,
          iterationsCollectionID,
          originalCategoryDoc.$id,
          { category: oldCategory }
        );
      }

      // rollback sign docs
      for (const doc of affectedSignDocs) {
        await databases.updateDocument(
          databaseID,
          webpMetadataCollectionID,
          doc.id,
          { category: doc.category }
        );
      }
    } catch (rollbackError) {
      console.error("Rollback FAILED:", rollbackError);
      // at this point → manual intervention needed
    }

    return { success: false, error };
  }
}
export async function updateCategoryName(documentId, newCategory) {
  const databases = new Databases(getClient());

  try {
    return await databases.updateDocument(
      databaseID,
      iterationsCollectionID,
      documentId,
      {
        category: newCategory,
      }
    );
  } catch (error) {
    console.error("Failed to update category:", error);
    return error;
  }
}


// ?
async function updateCategory(documents, databases) {
  if (documents.total > 0) {
    const document = documents.documents[0];
    const newVersion = parseInt(document.iteration) + 1;
    await databases.updateDocument(
      databaseID,
      iterationsCollectionID,
      document.$id,
      { iteration: newVersion }
    );
  }
}
export async function deleteCategoryAndData(row) {
  const client = getClient();
  const databases = new Databases(client);

  try {
    // Step 1: Delete the category 
    await databases.deleteDocument(databaseID, iterationsCollectionID, row.$id);

    // Step 2: Get all related documents from webpMetadataCollectionID
    const relatedDocs = await databases.listDocuments(
      databaseID,
      webpMetadataCollectionID,
      [Query.equal("category", row.category)]
    );

    // Step 3: Delete each related document and associated files
    if (relatedDocs.total > 0) {
      const storage = new Storage(client);
      const deletePromises = relatedDocs.documents.map(async (doc) => {
        const audioFileId = doc.audioUrl.split("files")[1].split("/")[1];
        const webpFileId = doc.webpUrl.split("files")[1].split("/")[1];

        databases.deleteDocument(databaseID, webpMetadataCollectionID, doc.$id);
        storage.deleteFile(webpBucketID, webpFileId);
        storage.deleteFile(audioBucketID, audioFileId);
      });
      await Promise.all(deletePromises);
    }
    return {
      success: true,
      message: `Category '${row.category}' and related data deleted successfully.`,
    };

  } catch (e) {
    return {
      success: false,
      error: e.message || e,
    };
  }
}
export async function deleteCategory(row) {
  const databases = new Databases(getClient());
  try {
    return await databases.deleteDocument(
      databaseID,
      iterationsCollectionID,
      row.$id
    );
  } catch (e) {
    return e;
  }
}
export async function convertVideosToWebpFiles(rows, filePath) {
  let file_paths = [];
  for (const i in rows) {
    const row = rows[i];
    file_paths.push(`${filePath}/${row.filename}`);
  }

  let requestUrl = "https://127.0.0.1:5000/convert";

  file_paths.forEach((path, i) => {
    if (i === 0) {
      requestUrl = requestUrl + `?file_paths=${path}`;
    } else {
      requestUrl = requestUrl + `&file_paths=${path}`;
    }
  });
  return await axios.get(requestUrl);
}


async function duplicateWebpMetadataExist(enTitle, database) {
  const promise = await database.listDocuments(
    databaseID,
    webpMetadataCollectionID,
    [Query.equal("enTitle", enTitle //.toLowerCase()
    
    )]
  );
  return promise.total !== 0 ? [true, promise] : [false, []];
}
async function duplicateIterationDocumentExist(category, database) {
  try {
    const promise = await database.listDocuments(
      databaseID,
      iterationsCollectionID,
      [Query.equal("category", category //.toLowerCase()
      )]
    );
    // remove duplicate
    // for (let i in promise.documents) {
    //   database.deleteDocument(
    //     databaseID,
    //     process.env.REACT_APP_CATEGORIES_COLLECTION_ID,
    //     promise.documents[i].$id
    //   );
    // }
    return promise.total !== 0 ? [true, promise] : [false, []];
  } catch (e) {
    return false;
  }
}


// Discourse Type
export async function getDiscourseTypes() { 
  const databases = new Databases(getClient());

  let allDocuments = [];
  let lastDocument=null;
  const limit = 100;  //appwrite default limit is 100

  try {
    while (true) {
      const queries = [
        Query.orderDesc("$createdAt"),
        Query.limit(limit),
      ];

      if (lastDocument) {
        queries.push(Query.cursorAfter(lastDocument.$id));
      }

      const response = await databases.listDocuments(
        databaseID,
        discourseTypeCollectionID,
        queries
      );

      if (response.documents.length === 0) break;

      allDocuments.push(...response.documents);

      lastDocument = response.documents[response.documents.length - 1];

      if (response.documents.length < limit) break;
    }

    return {
      documents: allDocuments,
    };
  } catch (error) {
    console.error("Failed to fetch discourse types:", error);
    throw new Error(`Could not fetch discourse types. Please try again later.`);
  }
}
export async function addDiscourseType(discourse) {
  const databases = new Databases(getClient());

  try {
    // Step 1: Check for existing discourse with same english title
    const existing = await databases.listDocuments(
      databaseID,
      discourseTypeCollectionID,
      [Query.equal("discourseTypeName", discourse.discourseTypeName)]
    );

    if (existing.total > 0) {
      throw new Error(
        `The discourse type "${discourse.discourseTypeName}" already exist. Discourse type needs to be unique, please rename and try again.`
      );
    }

    // Step 2: Add the discourse
    return await databases.createDocument(
      databaseID,
      discourseTypeCollectionID,
      ID.unique(),
      discourse
    );
  } catch (error) {
    console.error("Error adding discourse type:", error);
    throw error; // re-throw for UI to handle
  }
}
export async function deleteDiscourseType(row) {
  const docId = row.$id;
  const databases = new Databases(getClient());

  try {
    // return 
    await Promise.all([
      // delete document
      databases.deleteDocument(databaseID, discourseTypeCollectionID, docId),
    ]);

    // Step 2: Get all related documents from discourseCollection
    const relatedDocs = await databases.listDocuments(
      databaseID,
      discourseCollectionID,
      [Query.equal("discourseType", row.discourseTypeName)]
    );

    // Step 3: Delete each related document 
    if (relatedDocs.total > 0) {
      const deletePromises = relatedDocs.documents.map(async (doc) => {
        databases.deleteDocument(databaseID, discourseCollectionID, doc.$id);
      
      });
      await Promise.all(deletePromises);
    }
    return {
      success: true,
      message: `Discourse type '${row.discourseTypeName}' and related data deleted successfully.`,
    };

  } catch (error) {
    return error;
  }
}

// export async function getDiscourseTypes() { 
//   const databases = new Databases(getClient());

//   try {

//       const response = await databases.listDocuments(
//         databaseID,
//         discourseTypeCollectionID,
//          [
//         Query.orderDesc("$createdAt"),
//       ]
//       );



//     return {
//       documents: response,
//     };
//   } catch (error) {
//     console.error("Failed to fetch discourse types:", error);
//     throw new Error(`Could not fetch discourse types. Please try again later.`);
//   }
// }


// Discourse
export async function getDiscourse() {
  const databases = new Databases(getClient());

  let allDocuments = [];
  let lastDocument=null;
  const limit = 100;  //appwrite default limit is 100

  try {
    while (true) {
      const queries = [
        Query.orderDesc("$createdAt"),
        Query.limit(limit),
      ];

      if (lastDocument) {
        queries.push(Query.cursorAfter(lastDocument.$id));
      }

      const response = await databases.listDocuments(
        databaseID,
        discourseCollectionID,
        queries
      );

      if (response.documents.length === 0) break;

      allDocuments.push(...response.documents);

      lastDocument = response.documents[response.documents.length - 1];

      if (response.documents.length < limit) break;
    }

    return {
      documents: allDocuments,
    };
  } catch (error) {
    console.error("Failed to fetch discourse:", error);
    throw new Error(`Could not fetch discourse. Please try again later.`);
  }
}
export async function getDiscourseByType(type) {
  const databases = new Databases(getClient());

  let allDocuments = [];
  let lastDocument=null;
  const limit = 100;  //appwrite default limit is 100

  try {
    while (true) {
      const queries = [
        Query.equal("discourseType", type),
        Query.orderDesc("$createdAt"),
        Query.limit(limit),
      ];

      if (lastDocument) {
        queries.push(Query.cursorAfter(lastDocument.$id));
      }

      const response = await databases.listDocuments(
        databaseID,
        discourseCollectionID,
        queries
      );

      if (response.documents.length === 0) break;

      allDocuments.push(...response.documents);

      lastDocument = response.documents[response.documents.length - 1];

      if (response.documents.length < limit) break;
    }

    return {
      documents: allDocuments,
    };
  } catch (error) {
    console.error(`Failed to fetch dicourse type: ${type}:`, error);
    throw new Error(
      `Could not fetch dicourse type: ${type}. Please try again later.`
    );
  }
}
export async function getDiscourseByTitle(title) {
  const databases = new Databases(getClient());
  try {
    return await databases.listDocuments(
      databaseID,
      discourseCollectionID,
      [Query.equal("discourseTitle", title), Query.limit(100)]

      // [Query.equal("category", category), Query.limit(100)],
      // [Query.orderAsc("storyTitle"), Query.limit(100)]
    );
  } catch (error) {
    console.error(`Failed to fetch dicourse:`, error);
    throw new Error(`Could not fetch data. Please try again later.`);
  }
}
export async function searchDiscourse(searchTerm) {
  const databases = new Databases(getClient());

  try {
    const result = await databases.listDocuments(
      databaseID,
      discourseCollectionID,
      [Query.startsWith("discourseTitle", searchTerm), Query.limit(5)]
    );

    const finalResult = result.documents.map((doc) => ({
      $id: doc.$id,
      discourseTitle: doc.discourseTitle,
    }));

    return { documents: finalResult };
  } catch (error) {
    console.error(`${searchTerm} not found`, error);
    throw new Error(`${searchTerm} not found`);
  }
}

export async function addDiscourse(discourse) {
  const databases = new Databases(getClient());

  try {
    // Step 1: Check for existing discourse with same title
    const existing = await databases.listDocuments(
      databaseID,
      discourseCollectionID,
      [Query.equal("discourseTitle", discourse.discourseTitle)]
    );

    if (existing.total > 0) {
      throw new Error(
        `The title "${discourse.discourseTitle}" already exist for another discourse. Discourse title needs to be unique, please rename the title and try again.`
      );
    }

    // Step 2: Add the discourse
    return await databases.createDocument(
      databaseID,
      discourseCollectionID,
      ID.unique(),
      discourse
    );
  } catch (error) {
    console.error("Error adding discourse:", error);
    throw error; // re-throw for UI to handle
  }
}
export async function updateDiscourse(rows) {
  const databases = new Databases(getClient());

  try {
    // 1. Check if the title is already used by another document
    const duplicateDiscourseTitles = [];
    for (const row of rows) {
      const existing = await databases.listDocuments(
        row["$databaseId"],
        row["$collectionId"],
        [
          Query.equal("discourseTitle", row["discourseTitle"]),
          Query.notEqual("$id", row["$id"]), // exclude current document
        ]
      );
      if (existing.total > 0) {
        duplicateDiscourseTitles.push(row["discourseTitle"]);
      }
    }
    if (duplicateDiscourseTitles.length > 0) {
      const duplicates = duplicateDiscourseTitles
        .map((t) => `"${t}"`)
        .join(", ");
      throw new Error(
        `The following title : ${duplicates} already exist for another discourse. Discourse title needs to be unique, please rename the title and try again.`
      );
    }

    // 2. Proceed to update if unique
    for (const row of rows) {
      const data = {
        discourseTitle: row["discourseTitle"],
        discourseUrl: row["discourseUrl"],
        discourseDescription: row["discourseDescription"],
        discourseType: row["discourseType"],
      };

      await databases.updateDocument(
        row["$databaseId"],
        row["$collectionId"],
        row["$id"],
        data
      );
    }
    return { success: true };
  } catch (error) {
    console.error("Update failed:", error.message);
    throw error;
  }
}
export async function deleteDiscourseInDatabase(row) {
  const docId = row.$id;
  const databases = new Databases(getClient());

  try {
    return await Promise.all([
      // delete document
      databases.deleteDocument(databaseID, discourseCollectionID, docId),
    ]);
  } catch (error) {
    return error;
  }
}


// Feedback
export async function getFeedback(type, date) {
  const databases = new Databases(getClient());

  if (type === "single") {
    // start : to avoid one day behind when converting ISO format
    const startOfDay = date.startOf("day").unix();
    const endOfDay = date.endOf("day").unix();

    const startingDay = new Date(startOfDay * 1000);
    const endingDay = new Date(endOfDay * 1000);
    // end

    const startingISODate = startingDay.toISOString();
    const endingISODate = endingDay.toISOString();

    return await databases.listDocuments(databaseID, feedbacksCollectionID, [
      Query.greaterThanEqual("$createdAt", startingISODate),
      Query.lessThanEqual("$createdAt", endingISODate),
      Query.limit(100),
      Query.orderDesc("$createdAt")
    ]);
  } else if (type === "range") {
    // start : to avoid one day behind when converting ISO format
    const startOfDay = date["startDate"].startOf("day").unix();
    const endOfDay = date["endDate"].endOf("day").unix();

    const startingDay = new Date(startOfDay * 1000);
    const endingDay = new Date(endOfDay * 1000);
    // end

    const startingISODate = startingDay.toISOString();
    const endingISODate = endingDay.toISOString();

    return await databases.listDocuments(databaseID, feedbacksCollectionID, [
      Query.greaterThanEqual("$createdAt", startingISODate),
      Query.lessThanEqual("$createdAt", endingISODate),
      Query.orderDesc("$createdAt")
    ]);
  } else if (type === "all") {
    return await databases.listDocuments(databaseID, feedbacksCollectionID, [
      Query.orderDesc("$createdAt") // newest first
    ]);
  }
}
export async function addFeedback(data) {
  const databases = new Databases(getClient());
  try {
    return await databases.createDocument(
      databaseID,
      feedbacksCollectionID,
      ID.unique(),
      data
    );
  } catch (error) {
    console.error(`Failed to submit.`, error);
    throw new Error(`Could not sumbit feedback. Please try again later.`);
  }
}
export async function deleteFeedback(row) {
  const docId = row.$id;
  const databases = new Databases(getClient());
  try {
    return await Promise.all([
      databases.deleteDocument(databaseID, feedbacksCollectionID, docId),
    ]);
  } catch (error) {
    return error;
  }
}







//back up
// export async function uploadAll(rows) {
//     const client = getClient();
//     const storage = new Storage(client);
//     const databases = new Databases(client);
//     let responses = [];

//     let categories = [];

//     for (let i = 0; i < rows.length; i++) {
//         const docID = ID.unique();

//         try {
//             const [webpUploadResponse, audioUploadResponse] = await Promise.all([
//                 // upload webp
//                 storage.createFile(webpBucketID, ID.unique(), rows[i].webpFile),
//                 // upload audio
//                 storage.createFile(audioBucketID, ID.unique(), rows[i].audioFile),
//             ]);

//             const webpFileID = webpUploadResponse.$id;
//             const audioFileID = audioUploadResponse.$id;

//             const webpUrl = `https://${serverIP}/v1/storage/buckets/${webpBucketID}/files/${webpFileID}/view?project=${projectID}`;
//             const audioUrl = `https://${serverIP}/v1/storage/buckets/${audioBucketID}/files/${audioFileID}/view?project=${projectID}`;

//             // check if duplicate webp-metadata exist
//             // if exist then remove old webp file and audio file
//             // then update webpUrl and audioUrl with new webpUrl & audioUrl
//             const [doesExist, data] = await duplicateWebpMetadataExist(rows[i].enTitle, databases);

//             if (doesExist) {
//                 const docId = data.documents[0].$id;
//                 // remove previous webp and audio
//                 const oldWebpFileId = data.documents[0].webpUrl.split("/")[8]
//                 const oldAudioFileId = data.documents[0].audioUrl.split("/")[8]
//                 // to handle exception if the file doesn't exist
//                 try {
//                     await Promise.all([
//                         storage.deleteFile(webpBucketID, oldWebpFileId),
//                         storage.deleteFile(audioBucketID, oldAudioFileId)
//                     ]);
//                 } catch (e) {
//                 }

//                 // update webp metadata
//                 await databases.updateDocument(
//                     databaseID,
//                     webpMetadataCollectionID,
//                     docId,
//                     {
//                         enTitle: data.documents[0].enTitle,
//                         dzTitle: data.documents[0].dzTitle,
//                         category: data.documents[0].category,
//                         categories: data.documents[0].categories,
//                         webpUrl: webpUrl,
//                         audioUrl: audioUrl,
//                         webpUrls: [webpUrl], // overwrites old webp
//                         audioUrls: [audioUrl], // overwrites old audio
//                     }
//                 );
//             }
//             else {
//                 // create new webp metadata
//                 await databases.createDocument(
//                     databaseID,
//                     webpMetadataCollectionID,
//                     docID,
//                     {
//                         enTitle: rows[i].enTitle.toLowerCase(),
//                         dzTitle: rows[i].dzTitle,
//                         category: rows[i].category.toLowerCase(),
//                         categories: [rows[i].category.toLowerCase()],
//                         webpUrl: webpUrl,
//                         audioUrl: audioUrl,
//                         webpUrls: [webpUrl],
//                         audioUrls: [audioUrl]
//                     }
//                 );
//             }

//             responses.push({
//                 [rows[i].filename]: [
//                     webpUploadResponse,
//                     audioUploadResponse,
//                     // metadataUploadResponse,
//                 ],
//             });

//             // add category & increment iteration
//             if (!categories.includes(rows[i].category)) {
//                 categories.push(rows[i].category);
//                 const result = await addCategory(categories[i]);
//                 if (result[0] === true) {
//                     await updateCategory(result[1], databases);
//                 }
//             }
//         } catch (error) {
//             return error;
//         } finally {
//         }
//     }
//     return responses;
// }

// export async function updateWepMetadata(rows, toDeleteFiles) {
//     deleteFiles(toDeleteFiles).then(()=>{})

//     const client = getClient();
//     const storage = new Storage(client);
//     const databases = new Databases(client);
//     let _c = 0
//     try {
//         for (const row of rows) {
//             let _webpUrls = [...row.webpUrls]
//             let _audioUrls = [...row.audioUrls]
//             let _count = 0;
//             // check if webUrls or audios are in blob to upload to
//             for(const webpUrlOrBlob of row.webpUrls){
//                 if(webpUrlOrBlob.includes("blob")){
//                     try{
//                         _webpUrls = _webpUrls.filter((u) => !u.includes("blob"))

//                         for(const file of row.webpFiles){
//                             const _webpFileID = await storage.createFile(webpBucketID, ID.unique(), file)
//                             const urr = `https://${serverIP}/v1/storage/buckets/${webpBucketID}/files/${_webpFileID.$id}/view?project=${projectID}`;
//                             _webpUrls = [..._webpUrls, urr]
//                         }
//                         break;
//                     } catch (error){
//                         _webpUrls = _webpUrls.filter((u)=>u!==webpUrlOrBlob)
//                     }
//                 }
//                 _count++
//             }
//             _count = 0
//             for(const audioUrlOrBlob of row.audioUrls) {
//                 if(audioUrlOrBlob.includes("blob")){
//                     try{
//                         _audioUrls = _audioUrls.filter(u => !u.includes("blob"))
//                         for(const audioFile of row.audioFiles){
//                             const _audioFileID = await storage.createFile(audioBucketID, ID.unique(), audioFile)
//                             const urrAudio = `https://${serverIP}/v1/storage/buckets/${audioBucketID}/files/${_audioFileID.$id}/view?project=${projectID}`
//                             _audioUrls = [..._audioUrls, urrAudio]
//                         }
//                     } catch (error){
//                         _audioUrls = _audioUrls.filter(u => u!==audioUrlOrBlob)
//                     }
//                 }
//                 _count++
//             }
//             const data = {
//                 audioUrl: _audioUrls[0],
//                 categories: row["categories"],
//                 category: row["category"],
//                 dzTitle: row["dzTitle"],
//                 enTitle: row["enTitle"],
//                 webpUrl: _webpUrls[0],
//                 webpUrls: _webpUrls,
//                 audioUrls: _audioUrls,
//             }
//             await databases.updateDocument(row["$databaseId"], row["$collectionId"], row["$id"], data)
//             _c++
//         }
//     } catch (error) {
//         return error;
//     }
// }
